import { Pipe, PipeTransform } from '@angular/core';

import { SortEvent } from './sort.model';
import { sortAscFactory, sortDesFactory } from './sort.service';

type Data = Record<string, never>;

export type SortFunction = (a: Data, b: Data) => number;

@Pipe({
  name: 'sort',
  standalone: false,
})
export class SortPipe implements PipeTransform {
  transform(elements: unknown[], sortEvent?: SortEvent | SortFunction): any {
    elements = elements ?? [];

    if (sortEvent == null) {
      return elements ?? [];
    }

    if (typeof sortEvent === 'function') {
      return elements.sort(sortEvent);
    }

    const sortingFactory = sortEvent.order === 1 ? sortAscFactory : sortDesFactory;
    const sortFn = sortingFactory(sortEvent.by);
    return elements.sort(sortFn);
  }
}
